export class FinancePosition {
  public totalProjectedD1Risk: number = null;
  public availableForWithdrawal: number = null;
  public balanceTotal: number = null;
  public riskType: number = null;
  public avaibleBalance: number = null;
  public currentFinancialBalance: number = null;
  public dateD1: string = null;
  public dateD2: string = null;
  public dateD3: string = null;
  public projectedD1: number = null;
  public projectedD2: number = null;
  public projectedD3: number = null;
  public projectedDM3: number = null;
  public availableOnAccountD0: number;
  public balanceD0: number;
  /** Saldo sem considerar garantia */
  public balanceUsedToValidateFuture: number;
  /** Saldo sem considerar garantia */
  public balanceUsedToValidateStock: number;

  static createMock() {
    return {
      availableOnAccountD0: 0,
      totalProjectedD1Risk: 0,
      availableForWithdrawal: 0,
      balanceTotal: 300,
      riskType: 0,
      avaibleBalance: 0,
      currentFinancialBalance: 0,
      dateD1: "",
      dateD2: "",
      dateD3: "",
      projectedD1: 10,
      projectedD2: 20,
      projectedD3: 30,
      projectedDM3: 40,
      balanceD0: 0,
      balanceUsedToValidateFuture: 0,
      balanceUsedToValidateStock: 0,
    }
  }
}
